export const environment = {
    environmentFileName: 'environment.integ.ts',
    production: false,
    apiMocking: false,
    abaqusApiUrl: 'https://abaqus-int.digital.tecnalia.dev',
    // abaqusApiKey: '4Xhj9VT3.yeUdlsXhiU64bhQBKq23iJ0xq5sMcqWu', Previous
    abaqusApiKey: 'mkN40RSR.GD8QkiRi04imKJwuowjJELEcvQEwDZu4',
    iqarusApiUrl: 'https://aqre-qa.ap.basf.net',
    iqarusApiKey: 'XjlxPTDMbiEaellM4v5bWwrJfJlrR5QRVaYSavdmol8',
    speadApiUrl: 'https://app-qa.roqs.basf.net/radar_api',
    speadApiKey: 'c38f68ca88599426c65eb80470adc76f27cd3501',
    faviconFile: 'favicon-purple.ico',
    environmentNameSuffix: ' - int'
};
